import { NavigationItemType } from "@/types/NavigationItem"
import {
  CreditCard,
  DollarSign,
  FileText,
  LayoutDashboard,
  Package,
  PackagePlus,
  Receipt,
  Settings,
  Shield,
  Tag,
  Users,
  UsersIcon,
  Wallet,
} from "lucide-react"

export const NavigationItemList: NavigationItemType[] = [
  {
    label: "Dashboard",
    link: "/",
    Icon: LayoutDashboard,
  },
  {
    label: "Clients",
    link: "/clients",
    Icon: Users,
  },
  {
    label: "Abonnements",
    link: "/abonnements",
    Icon: CreditCard,
  },
  {
    label: "Transactions",
    link: "/transactions",
    Icon: Wallet,
  },
  {
    label: "Plans",
    link: "/offres",
    Icon: Package,
  },
  // {
  //   label: "Paiements",
  //   link: "/paiements",
  //   Icon: ReceiptLong,
  // },
  {
    label: "Fonctionnalités & Add-on",
    link: "/fonctionnalites-et-add-on",
    Icon: PackagePlus,
  },
  {
    label: "Code promo",
    link: "/code-promo",
    Icon: Tag,
  },
  {
    label: "Facturation",
    link: "/facturation",
    Icon: Receipt,
  },
  {
    label: "Supports Clients",
    link: "/supports-clients",
    Icon: UsersIcon,
  },
  {
    label: "Revenues",
    link: "/revenues",
    Icon: DollarSign,
  },

  // {
  //   label: "Activités",
  //   link: "/activites",
  //   Icon: PointOfSaleOutlined,
  // },
  {
    label: "Logs system",
    link: "/logs-system",
    Icon: FileText,
  },
  // {
  //   label: "Support",
  //   link: "/membres-du-support",
  //   Icon: SupportAgentOutlined,
  // },
  {
    label: "Rôles",
    link: "/roles",
    Icon: Shield,
  },
  // {
  //   label: "Affectations Closes",
  //   link: "/affectations-closes",
  //   Icon: DoneAllOutlined,
  // },

  // {
  //   label: "Rapports",
  //   link: "/rapports-statistiques",
  //   Icon: BarChartOutlined,
  // },

  {
    label: "Paramètres",
    link: "/parametres",
    Icon: Settings,
  } /* 
  {
    label: "Se déconnecter",
    link: "/logout",
    Icon: LogoutRounded,
  }, */,
]
